import { ChartProperty } from 'app/shared/components/hydro-graph';
import { GraphChartConfiguration } from 'app/shared/components/hydrograph/hydrograph-data/hydrograph-data-model';
import { LightningChartObject } from 'app/shared/components/hydrograph/lightning-chart-object/lightning-chart-object';
import { BasicSeriesData } from 'app/shared/models/hydrographNEW';
import { OptimizedViewData } from 'app/shared/models/view-data';
import { BehaviorSubject } from 'rxjs';


export interface CustomDashboardGraphObject {
    name: string;
    isExpand: boolean;
    graphId: string;
    originalData: BasicSeriesData[];
    config: GraphChartConfiguration,
    dates: number[];
    dataAverage: number,
    isLoading: BehaviorSubject<boolean>;
    graphType: GraphType;
    headerDates: number[];
    groupings: number[][];
    index: number;
    noData:Array<GraphConfigurationNoData>;
    inactiveLocation?: boolean;
    chart?: LightningChartObject;
}

export class CustomGraphs {
    public customerId: number;
    public configurations: Array<GraphConfiguration>;
    constructor() {
        this.configurations = new Array<GraphConfiguration>(0);
    }
}

export interface CustomOptimizedViewData extends OptimizedViewData {
    color: string;
}

export interface GraphConfiguration {
    graphId?: string;
    name?: string;
    startDate?: string | Date;
    endDate?: string | Date;
    series?: Array<GraphConfigurationSeries>;
    graphType?: GraphType;
    users?: string[];
    dataAverage?: number;
    graphAccess?: number;
    rolling?: boolean;
    dateSpan?: number;

    /** Comes only from API on load of existing conf */
    data?: CustomOptimizedViewData[];

    // TODO: Separate it someday - UI addition to an API model
    dataLoading?: BehaviorSubject<boolean>;
    isLoading?: boolean;
    noData?:Array<GraphConfigurationNoData>;
    index?: number;
    inactiveLocation?: boolean;
}

export interface GraphConfigurationSeries {
    lid: number;
    eid: number;
    color: string;
    cid?: number;
    eidX?: number;
    eidY?: number;
    eidXName?: string;
    eidYName?: string;
    locationName?: string;
}

export interface GraphConfigurationNoData {
    location: string;
    eidXName: string;
    eidYName?: string;
}

export class GraphOptions {
    public graphId: string;
    public name: string;
    public startDate: Date;
    public endDate: Date;
    public options?: ChartProperty;
}

export class SeriesData {
    public series: Array<string>;
}

export class TimeInterval {
    public days?: number;
    public hours?: number;
    public minutes?: number;
}

export enum AccessType {
    Public = 0,
    Private = 1,
}

export enum GraphType {
    Hydrograph = 0,
    Scattergraph = 1,
}
